var React = require('react');

function Qa (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#8d1b3d","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 0v480h158.4l97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6L256.1 80l-97.7-26.7 97.8-26.6L158.3 0H0z","key":1})]);
}

Qa.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Qa;

Qa.default = Qa;
